export default __webpack_public_path__ + "static/media/apps-workergrading.3dfb2b5d.png";